import { render, staticRenderFns } from "./SearchResultStatistics.vue?vue&type=template&id=37af7fb2&scoped=true"
import script from "./SearchResultStatistics.vue?vue&type=script&lang=js"
export * from "./SearchResultStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af7fb2",
  null
  
)

export default component.exports